;(function () {
  var nav = document.querySelector('.foundry--nav')
  if (nav) {
    var toggle = nav.querySelector('.nav--toggle')
    toggle.addEventListener('click', function (e) {
      toggle.classList.toggle('active')
    })
    var mainNavEntries = nav.querySelectorAll('.main--nav .nav--group')
    mainNavEntries.forEach(function (group) {
      var link = group.querySelector('.nav--link')
      if (link) {
        link.addEventListener('click', function (e) {
          group.classList.toggle('active')
        })
      }
    })
  } else {
    $('#side-menu').metisMenu()
    function leftNav() {
      var _nav = $('#side_nav')
      var _hamIcon = $('#hamburger')
      var _overly = $('#overlay_div')

      if (!_nav.is(':animated')) {
        if (_nav.hasClass('sideNav_isOff')) {
          _hamIcon.addClass('cross')
          _hamIcon.animate({ left: 175 }, 500)
          _overly.fadeIn()
          _nav
            .addClass('sideNav_isOn')
            .show()
            .animate({ left: 0 }, 400, 'linear', function () {
              _nav.removeClass('sideNav_isOff')
              $('body,html').addClass('modal-open')
            })
        } else {
          _hamIcon.removeClass('cross')
          _hamIcon.animate({ left: 0 }, 400)

          _nav.animate({ left: -225 }, 500, 'linear', function () {
            _nav
              .addClass('sideNav_isOff')
              .removeClass('sideNav_isOn')
              .removeAttr('style')
            $('body,html').removeClass('modal-open')
          })
          _overly.hide()
        }
      }
    }

    $('#hamburger').click(function () {
      leftNav()
    })
  }
})()
